import { TextInput, useInputValidation } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  value: string;
  type: string;
  onChange: (email: string) => void;
}

export function TextGdpr({ value, onChange, type }: IProps) {
  const [textRef, isTextValid, errorMessage] = useInputValidation(value, [
    {
      validation: (value) => value != undefined && value.length > 0,
      message: 'Lýsingu vantar',
    },
  ]);

  return (
    <TextInput
      inputRef={textRef}
      isValid={isTextValid}
      errorMessage={errorMessage}
      label={
        type === 'Deletion'
          ? `Hvaða persónuupplýsingar óskar þú eftir að verði eytt?`
          : type === 'Correction'
          ? `Hvaða persónuupplýsingar óskar þú eftir að verði leiðrétt?`
          : `Hvaða persónuupplýsingar óskar þú eftir að verði takmarkaðar?`
      }
      setHeight="236px"
      value={value}
      onChange={(e) => {
        const value = e.currentTarget.value;
        onChange(value);
      }}
    />
  );
}
